import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { playerStatsNavSelector } from 'store/modules/match-centre/player-stats/selectors';
import { UPDATE_NAV_ITEM } from 'store/modules/match-centre/player-stats/actions';

export const TeamsNavItem = ({
    homePid,
    awayPid,
    homeName,
    awayName,
    homeNickname,
    awayNickname
}) => {
    const dispatch = useDispatch();
    const nav = useSelector(playerStatsNavSelector);

    // Use full name with nickname as fallback
    const homeLabel = homeName || homeNickname;
    const awayLabel = awayName || awayNickname;

    return (
        <Select
            items={['Both', homeLabel, awayLabel]}
            initialSelectedItem={nav.teams}
            activeItem={nav.teams}
            label={getTranslation('label.teams')}
            onSelectedItemChange={({ selectedItem }) => {
                let teamPid = null;
                if (selectedItem === homeLabel) {
                    teamPid = homePid;
                } else if (selectedItem === awayLabel) {
                    teamPid = awayPid;
                }

                // teamPid used to filter Player Stats Table rows
                dispatch(
                    UPDATE_NAV_ITEM.request({
                        navItem: 'teams',
                        value: selectedItem
                    })
                );
                dispatch(
                    UPDATE_NAV_ITEM.request({
                        navItem: 'teamPid',
                        value: teamPid
                    })
                );
            }}
        />
    );
};

TeamsNavItem.propTypes = {
    homePid: PropTypes.string.isRequired,
    awayPid: PropTypes.string.isRequired,
    homeName: PropTypes.string,
    awayName: PropTypes.string,
    homeNickname: PropTypes.string.isRequired,
    awayNickname: PropTypes.string.isRequired
};
